import { faPrint } from '@fortawesome/pro-solid-svg-icons'
import { notification } from 'antd'
import FabButton from '../common/FabButton'
import { TimesheetsFilters } from './timesheetsModel'
import { useTimesheetsPrintReportMutation } from './timesheetsQueries'

type Props = {
  filters: TimesheetsFilters
}

const TimesheetsPrintButton = ({ filters }: Props) => {
  const printMutation = useTimesheetsPrintReportMutation(url => {
    window.open(url, '_blank')
  })

  const handlePrint = () => {
    if (!filters.starting) {
      notification.warning({
        message: 'Please select a starting date for the timesheets report.',
        description: 'You may also select an ending date, crew member, or search query and filter by submitted and exported entries.',
      })
      return
    }
    printMutation.mutate(filters)
  }

  return <FabButton
    icon={faPrint}
    title="Print for Selected Date Range and Crew Members"
    onClick={handlePrint}
    disabled={printMutation.isLoading}
  />
}

export default TimesheetsPrintButton
